<div class="flex-auto flex items-center container justify-content-center">
  <div class="text-[16px] md:text-[16px] md:font-medium text-center sm:block subheading-2">
    <span *ngIf="user?.organisation_id != 13" [style.font-family]="'var(--vex-font)'">© Copyright {{this.currentYear}}. All rights reserved.</span>
    <span *ngIf="user?.organisation_id === 13" [style.font-family]="'var(--vex-font)'">Powered By </span>
    <span class="text-info cursor-pointer" (click)="openUrl('https://volmint.com')" [style.font-family]="'var(--vex-font)'"> Volmint Technologies Private Limited.</span>
  </div>
</div>
